export default __webpack_public_path__ + "static/media/Background_00097.bbfa4ff3.png";